import { enqueueSnackbar } from "notistack";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { consumeFlashMessage } from "./flash";

// currently works only for authRoutes and mainRoutes
export function FlashMessageListener() {
  const location = useLocation();

  // is triggered with 1st render or navigation
  useEffect(() => {
    const msg = consumeFlashMessage();
    if (msg) {
      enqueueSnackbar(msg.text, {
        variant: msg.variant ?? "default",
        persist: msg.persist ?? false,
      });
    }
  }, [location.pathname]);

  return null;
}
